<template>
  <div class="container is-fluid" v-if="loaded && is_checked">
    <div class="columns">
      <div class="column">
        <Hero />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <router-view/>
      </div>
    </div>
    <Help />
  </div>
  <div v-if="!loaded && is_checked">
    <Loader type="error"/>
  </div>
  <div v-if="!is_checked">
    <Loader type="init"/>
  </div>
</template>

<script>
import Hero from "@/components/Hero";
import Cookies from 'js-cookie'
import Loader from "@/components/Loader";
import Help from "@/components/Help";

export default {
  components: { Help, Hero, Loader },
  async beforeMount() {
    await this.check_session()
  },
  data() {
    return {
      loaded: false,
      is_checked: false
    }
  },
  methods: {
    check_session: async function () {
      console.log('Инициализация получения токена\n--')
      console.log('Попытка взять токен из Cookies')
      if (Cookies.get('token')) {
        this.$store.dispatch('TOKEN', Cookies.get('token'))
        console.log('Взял токен из Cookies')
        await this.makeRequest(this.$store.getters.USER.guid)
      } else {
        if (this.$config.ENABLE_REDIRECT) {
          window.location.replace(`${this.$config.SSL}://${this.$config.AUTH_ADDRESS}/?app_id=${this.$config.APP_NAME}`);
        }
        console.warn('Попытка взять токен из Query неудачна')
      }
      this.is_checked = true
    },
    makeRequest: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.DB}/${this.$config.API_VERSION}/GetUserInfo`
      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.$store.getters.TOKEN
        }
      }
      await fetch(url, properies)
          .then(response => response.text())
          .then(result => {
            this.$store.dispatch('USER_DATA', JSON.parse(result)[0])
            this.loaded = true
            console.log('Доступ разрешён!\nПользователь: '+JSON.parse(result)[0]['Наименование'])
          })
    }
  }
}
</script>

<style lang="scss">
@font-face {
  font-family: 'DinCy';
  src: url('assets/DinCyRg.ttf');
}

* {
  font-family: 'DinCy', monospace !important;
}
html {
  position: relative;
  height: 100vh;
  width: 100vw;
}
html:after {
  content : "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  background-image: url("@/assets/lion.png");
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: 110% center;
  width: 100%;
  height: 100%;
  opacity : 0.03;
  z-index: -1;
}

/* W3C standard
   сейчас только для Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: rgb(45, 140, 0) rgba(0,0,0,0.03);
}

/* для Chrome/Edge/Safari */
*::-webkit-scrollbar {
  width: 10px;
}
*::-webkit-scrollbar-track {
  background: rgba(0,0,0,0.03);
}
*::-webkit-scrollbar-thumb {
  border: 3px solid transparent;
  border-radius: 100px;
  background-color: rgb(45, 140, 0);
  background-clip: content-box;
}

.my-not-scrollable {
  position: sticky !important;
  top: 10px !important;
  z-index: 20 !important;
}
</style>
